import { Chart, ChartData, ChartDataset, ChartOptions } from "chart.js/auto"
import { IChartDataSet } from "../model"

export const createChart = (
  type: "line" | "bar",
  divId: string,
  dataSets: IChartDataSet[],
  smallFonts: boolean
): Chart => {
  const options: ChartOptions = smallFonts
    ? {}
    : {
        plugins: {
          legend: {
            labels: {
              // This more specific font property overrides the global property
              font: {
                size: 20,
                weight: "bold"
              }
            }
          }
        },
        scales: {
          x: {
            ticks: {
              font: {
                size: 16 // set the font size for x-axis labels
              }
            }
          },
          y: {
            ticks: {
              font: {
                size: 16 // set the font size for x-axis labels
              }
            }
          }
        }
      }
  const chart = new Chart(divId, {
    type,
    data: getChartData(dataSets),
    options
  })
  return chart
}

export const updateChart = (chart: Chart, dataSets: IChartDataSet[]): Chart => {
  setData(chart, getChartData(dataSets))
  return chart
}

const getChartData = (dataSets: IChartDataSet[]): ChartData => {
  const xValues: any[] = []
  const chartDataSets: ChartDataset[] = []
  for (const dataSet of dataSets) {
    const chartDataSet: ChartDataset = {
      label: dataSet.label,
      backgroundColor: dataSet.backgroundColor,
      borderColor: dataSet.borderColor,
      borderWidth: dataSet.borderWidth || 1,
      borderRadius: dataSet.borderRadius || 0,
      borderSkipped: typeof dataSet.borderSkipped === "boolean" ? dataSet.borderSkipped : true,
      data: []
    }
    for (const entry of dataSet.data) {
      if (xValues.indexOf(entry.x) === -1) {
        xValues.push(entry.x)
      }
      chartDataSet.data.push(entry.y)
    }
    chartDataSets.push(chartDataSet)
  }
  return { labels: xValues, datasets: chartDataSets }
}

const setData = (chart: Chart, data: ChartData) => {
  chart.data = data
  chart.update()
}
